import React from "react";
import "./Projects.css";
import ProjectInfo from "./ProjectInfo";

const Projects = () => {
  return (
    <section className="projects section" id="projects">
      <h2 className="section_title">Projects</h2>
      <span className="section_subtitle">My best work</span>

      <ProjectInfo />
    </section>
  );
};

export default Projects;
